import React from 'react';
import { useTranslation } from 'react-i18next';
import PageArea from './PageArea';
import PageTitle from './PageTitle';

interface ComingSoonPageProps {
  titleKey: string;
}

const ComingSoonPage: React.FC<ComingSoonPageProps> = ({ titleKey }) => {
  const { t } = useTranslation();

  return (
    <PageArea>
      <PageTitle title={t(titleKey)} subtitle={t('common.comingSoon')} />
    </PageArea>
  );
};

export default ComingSoonPage;
